import React, { useEffect, useState } from "react";
const LocationGuard = ({ children }) => {
  const [isAllowedState, setIsAllowedState] = useState(null);
  const [locationChecked, setLocationChecked] = useState(false);
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async function (pos) {
          try {
            const lat = pos?.coords?.latitude;
            const lon = pos?.coords?.longitude;
            if (!lat || !lon) {
              setIsAllowedState(false);
              setLocationChecked(true);
              return;
            }
            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
            );
            if (!res.ok) throw new Error("Reverse API failed");
            const data = await res.json();
            const country = data?.address?.country || "";
            const city =
              data?.address?.city ||
              data?.address?.town ||
              data?.address?.village ||
              "";
            console.log("Country:", country);
            console.log("City:", city);
            let isAllowed = false;
            if (country === "India") {
              isAllowed = true;
            }
           if (country === "Uzbekistan") {
              isAllowed = true;
            }
           if (
              country === "United Arab Emirates" &&
              city.toLowerCase() === "Dubai"
            ) {
              isAllowed = true;
            }
            setIsAllowedState(isAllowed);
          } catch (error) {
            console.log(error);
            setIsAllowedState(false);
          }
          setLocationChecked(true);
        },
        function () {
          setIsAllowedState(false);
          setLocationChecked(true);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      setIsAllowedState(false);
      setLocationChecked(true);
    }
  }, []);
  if (!locationChecked) {
    return <div>Checking location...</div>;
  }
  if (isAllowedState === false) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h1>403</h1>
        <h2>Access Denied</h2>
      
        <button onClick={() => window.location.reload()}>
          Retry
        </button>
      </div>
    );
  }
  return children;
};
export default LocationGuard;

